import { render, staticRenderFns } from "./dietitian-calendar.page.vue?vue&type=template&id=1c667ff2&scoped=true&"
import script from "./dietitian-calendar.page.vue?vue&type=script&lang=js&"
export * from "./dietitian-calendar.page.vue?vue&type=script&lang=js&"
import style0 from "./dietitian-calendar.page.vue?vue&type=style&index=0&id=1c667ff2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c667ff2",
  null
  
)

export default component.exports